import { Component, ViewEncapsulation } from '@angular/core';
import { BreakpointService, ProductFacetNavigationComponent } from '@spartacus/storefront';
import { FacetActiveKbComponent } from '../facet-active-kb/facet-active-kb.component';
import { FacetListKbComponent } from '../facet-list-kb/facet-list-kb.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-facet-navigation',
    templateUrl: './facet-navigation.component.html',
    styleUrls: ['./facet-navigation.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        FacetActiveKbComponent,
        FacetListKbComponent,
        AsyncPipe,
    ],
})
export class FacetNavigationComponent extends ProductFacetNavigationComponent {
  constructor(protected override breakpointService: BreakpointService,
  ) {
    super(breakpointService);
  }



}
